export const supporters = [
  [2, 'Siang Lu'],
  [1, "Jonathan O'Brien"],
  [3, 'Alan B Brown'],
  [3, 'The Bagel'],
  [1, 'Scott Forbes'],
  [3, 'Tim Macanan'],
  [3, 'Jiayi Ying'],
];
